<template>
  <div>
    <v-card class="pl-5 pr-5">
      <h1>User Request</h1>
      <v-divider></v-divider>

      <div class="row" v-show="!isEdit">
        <div class="col">
          <ConfirmationDialog ref="confirm" />
          <v-simple-table>
            <template v-slot:default>
              <thead>
                <tr>
                  <th class="text-left">Publication</th>
                  <th class="text-left">Requested Date</th>
                  <th class="text-left"></th>
                  <th style="width: 100px"></th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="item in list" :key="item.id" :id="'svg' + item.id">
                  <td>{{ item.Publication.Title }}</td>
                  <td>{{ item }}</td>
                  <td></td>
                  <td>
                    <v-icon class="mr-2 icon-edit" @click="onEdit(item)"
                      >mdi-comment-edit</v-icon
                    >
                    <v-icon class="mr-2 icon-delete" @click="onDelete(item)"
                      >mdi-delete</v-icon
                    >
                  </td>
                </tr>
              </tbody>
            </template>
          </v-simple-table>
        </div>
      </div>
      <div class="row" v-show="!isEdit">
        <div class="col">
          <Pagination :paging="paging" v-on:next="onNextPage" />
        </div>
      </div>
    </v-card>
  </div>
</template>
<script>
import Notification from "@/components/Notification";
import ConfirmationDialog from "@/components/ConfirmationDialog";
import Pagination from "@/components/Pagination";
import * as api from "@/api";

export default {
  name: "UserRequest",
  components: {
    Notification,
    ConfirmationDialog,
    Pagination,
  },
  created() {
    this.getUserRequestByPagin();
  },
  methods: {
    onSearch() {
      this.paging.page = 1;
      this.paging.keyword = this.Search;
      this.getUserRequestByPagin();
    },
    getUserRequestByPagin() {
      this.list = [];
      new Promise((resolve, reject) => {
        api
          .getByPagin("user-request", this.paging)
          .then((response) => {
            resolve(response);
            this.paging.count = response.data.count;
            this.list = response.data.data;
            console.log(this.list);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    onNextPage(page) {
      console.log("onNextPage " + page);
      this.paging.page = page;
      this.paging.keyword = this.Search;
      console.log(this.paging);

      this.getUsersByPagin();
    },
  },
  data() {
    return {
      isEdit: false,
      list: [],
    };
  },
};
</script>



// WEBPACK FOOTER //
// src/views/UserRequest.vue